import {numberDayTask} from '../helpers';

export const TYPE_REMIND_TASK  = [
  { value: 0, label: 'Системное' },
  { value: 1, label: 'SMS' },
]
export const TYPE_REPEAT_TASK  = [
  { value: 0, label: 'Каждый день' },
  { value: 1, label: 'Каждую неделю' },
  { value: 2, label: 'Каждый месяц' },
  { value: 3, label: 'Каждый год' },
]

export const DAYS_TASK = numberDayTask();



export const styleSelectOrders = {
  container: (provided: Record<string, any>) => ({
    ...provided,
    maxWidth:250,
    width: '100%',
  }),
  control: (provided: Record<string, any>) => ({
    ...provided,
    minWidth: 150,
    height: 48,
    width: '100%',
    cursor: 'pointer',
    margin: 0,
    fontSize: 16,
    boxShadow: 'none',
  }),
  indicatorSeparator: (provided: Record<string, any>) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided: Record<string, any>) => ({
    ...provided,
    color: '#0656F8',
    ':hover': {
      color: '#0656F8',
    }
  }),
}

export const customStylesSelect = {
  container: (provided: Record<string, any>) => ({
    ...provided,
    width: '100%',
    cursor: 'pointer',
    margin: 0,
    fontSize: 16,
    boxShadow: 'none',
    maxWidth:600,
  }),
  control: (provided: Record<string, any>) => ({
    ...provided,
    minHeight: 48,
    width: '100%',
    cursor: 'pointer',
    fontSize: 16,
    boxShadow: 'none',
  }),
  indicatorSeparator: (provided: Record<string, any>) => ({
    ...provided,
    display: 'none'
  }),
  multiValue: (provided: Record<string, any>) => ({
    ...provided,
    borderRadius:32,
    // padding:'10px 12px',
    // div: {
    //   fontSize:16,
    // }
  }),
  dropdownIndicator: (provided: Record<string, any>) => ({
    ...provided,
    color: '#0656F8',
    ':hover': {
      color: '#0656F8',
    }
  }),
}

export const styleMultiSelectUser = {
  container: (provided: Record<string, any>) => ({
    ...provided,
    width: '100%',
    cursor: 'pointer',
    margin: 0,
    fontSize: 16,
    boxShadow: 'none',
  }),
  valueContainer: (provided: Record<string, any>) => ({
    ...provided,
    maxHeight: 150,
    minHeight: 48,
    // maxWidth: 390,
    minWidth: 150,
    overflow: 'auto'
  }),
  multiValue: (provided: Record<string, any>) => ({
    ...provided,
    borderRadius: 28,
    backgroundColor: '#F2F6F8',
    // padding: 5,
    'div:first-of-type': {
      '@media screen and (max-width:570px)':{
        display:'block'
      }
    }
  }),
  multiValueLabel: () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    WhiteSpace: 'pre-wrap !important',
    maxWidth: 220,
    padding: '0 10px',
  }),
  multiValueRemove: (provided: Record<string, any>) => ({
    ...provided,
    cursor: 'pointer',
    ':hover': {
      color: 'blue',
    },
  }),
  indicatorSeparator: (provided: Record<string, any>) => ({
    ...provided,
    display: 'none'
  }),
  dropdownIndicator: (provided: Record<string, any>) => ({
    ...provided,
    color: '#0656F8',
    ':hover': {
      color: '#0656F8',
    }
  }),
  control: (provided: Record<string, any>) => ({
    ...provided,
    width: '100%',
    maxWidth:600,
    '@media screen and (max-width:810px)':{
      width:'100%'
    }
  }),
  menu: (provided: Record<string, any>) => ({
    ...provided,
    zIndex: 1000
  }),
}

export const initialValuesTask = (userInfo: Record<string, any> )=> {
  return {
    title: '',
    source: undefined,
    order: null,
    user: userInfo.user_status === 'staff' ?  {value: userInfo.id ? userInfo.id : '', label:''} : null,
    description:'',
    deadline_at: null,
    groups: [],
    is_urgent: false,
    is_remind: false,
    is_repeat: false,
    client: null,
    phone: '',
    email: '',
    client_name: '',
    repeat_by: undefined,
    remind_type: undefined,
    remind_at: undefined,
    repeat_time_at: undefined,
    repeat_dow: undefined,
    repeat_day: undefined,
    repeat_month: undefined,
    repeat_count_remain: undefined,
    flagStaff: false
  }
}

export const defaultValueTabsGroup = {
  usersTab: { status: false },
  reminderTab: { status: false },
  repeatTab: { status: false },
  additionalTab: { status: false },
}